import { defineNuxtPlugin } from '#app';
import formatDatabaseDate from "~/utils/formatDatabaseDate";

export default defineNuxtPlugin(nuxtApp => {
    const isSuperAdmin = (auth) => {
        return auth.user?.isSuperAdmin;
    }
    const timestampDate = (value) => {
        if (!value) return '';
        return formatDatabaseDate(value);
    };

    nuxtApp.provide('timestampDate', timestampDate);
    nuxtApp.provide('isSuperAdmin', isSuperAdmin);
});
